<script>
  export let lightText;
  export let boldText;
</script>

<div class="formsectionheader">
  {lightText}<strong class="textbold maintypo">{boldText}</strong>
</div>
